module.exports = __webpack_public_path__ + "static/media/cookie.06b2e424.svg";